import { FormBuilderElementsMappingService } from "../builder/form-builder.elements-mapping.service";
const handleElementsValidation = (element, errorObj, shadowRoot, formRef) => {
  const tags = element.tags;
  const inputs = [...(tags == null ? void 0 : tags.input) || [], ...(tags == null ? void 0 : tags.select) || [], ...(tags == null ? void 0 : tags.textarea) || []];
  for (const input of inputs) {
    const inputHTML = shadowRoot.getElementById(input.id);
    if (!inputHTML.checkValidity()) {
      errorObj.hasError = true;
    }
  }
  formRef.current.reportValidity();
};
const validate = (elements, formRef, hostElement) => {
  var _a;
  const shadowRoot = (_a = hostElement == null ? void 0 : hostElement.querySelector("div")) == null ? void 0 : _a.shadowRoot;
  if (!shadowRoot) return false;
  const mappedElements = FormBuilderElementsMappingService.mapElementsByTheirHTMLTags(elements);
  const errorObj = {};
  for (const element of mappedElements) {
    handleElementsValidation(element, errorObj, shadowRoot, formRef);
  }
  return errorObj.hasError;
};
export const FormBuilderInputsValidationService = {
  validate
};
